import LlmPromptsEditor from "./components/llm-prompts-editor";
import { LLM_PROMPTS_DIALOG_ID } from "./constants";

export const LlmPromptsEditorDialog = Object.assign(LlmPromptsEditor, {
  dialogId: LLM_PROMPTS_DIALOG_ID,
});

export { LLM_PROMPTS_DIALOG_ID };
